import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { HeadlinesItemModel } from '@libs/cms/models';

@Component({
  selector: 'ui-headlines',
  styleUrls: ['./headlines.component.scss'],
  templateUrl: './headlines.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class HeadlinesComponent {
  public data: InputSignal<HeadlinesItemModel | undefined> = input();
  public level: InputSignal<number> = input(2);
}
